import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> ISO</li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>ISO 27001 Consulting</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  In today’s interconnected world, safeguarding sensitive data
                  is no longer optional — it is a business-critical necessity.
                  ISO/IEC 27001 is the globally recognized standard for
                  Information Security Management Systems (ISMS), designed to
                  protect organizations against data breaches, cyberattacks, and
                  regulatory penalties. Our ISO 27001 Compliance services help
                  your organization align with the requirements of the standard,
                  ensuring that your processes, people, and technologies work
                  together to secure business information and maintain customer
                  trust.
                </p>
              </div>
              {/* headings */}

              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  {
                    icon: "fa-arrows-down-to-people",
                    title: "Regulatory Confidence",
                    desc: "Demonstrates compliance with international laws, data protection regulations, and contractual obligations.",
                  },
                  {
                    icon: "fa-database",
                    title: "Risk Reduction",
                    desc: "Establishes a structured framework to identify, assess, and mitigate risks effectively.",
                  },
                  {
                    icon: "fa-shield-halved",
                    title: "Customer Assurance",
                    desc: "Builds confidence among stakeholders, partners, and clients by showcasing a proactive security posture.",
                  },
                  {
                    icon: "fa-table",
                    title: "Business Enablement",
                    desc: "Many enterprises require vendors to be ISO 27001 compliant — making it an enabler for new business opportunities.",
                  },
                  {
                    icon: "fa-business-time",
                    title: "Operational Excellence",
                    desc: "Embeds security into daily operations, reducing incidents and disruptions.",
                  },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/*-------- TAB AND PILL SEC ----------- */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "methodology", label: "Methodology" },
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content">
                    {/* Methodology */}
                    <div className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`} role="tabpanel">
                      <p>We follow a proven roadmap to help organizations achieve and maintain ISO 27001 compliance:</p>
                      <ul>
                        <li><b>Initial Assessment  :-</b> Review current security posture, policies, and practices.</li>
                        <li><b>Gap Analysis  :-</b> Identify gaps against ISO 27001 requirements.</li>
                        <li><b>Risk Assessment & Treatment Plan  :-</b> Develop a structured risk management strategy.</li>
                        <li><b>ISMS Documentation  :-</b> Draft required policies, procedures, and records.</li>
                        <li><b>Implementation Support  :-</b> Guide teams in deploying controls, awareness programs, and governance.</li>
                        <li><b>Compliance Validation  :-</b> Internal reviews and mock audits to ensure readiness.</li>
                        <li><b>Ongoing Compliance Management  :-</b> Periodic reviews and updates to maintain compliance.</li>
                      </ul>
                    </div>

                    {/* Key Benefits */}
                    <div className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`} role="tabpanel">
                      <ul>
                        <li>Achieve ISO 27001 compliance with confidence.</li>
                        <li>Strengthen defenses against cyber risks and data breaches.</li>
                        <li>Ensure continuous alignment with international standards.</li>
                        <li>Improve stakeholder trust and brand reputation.</li>
                        <li>Enable business growth by meeting partner and client requirements.</li>
                        <li>Create a sustainable compliance framework that evolves with threats.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`} role="tabpanel">
                      <p>With our ISO 27001 Compliance service, you receive:</p>
                      <ul>
                        <li><b>Gap Analysis Report :-</b> Detailed view of compliance gaps.</li>
                        <li><b>ISMS Documentation Package  :-</b> Policies, procedures, and templates.</li>
                        <li><b>Risk Register & Treatment Plan  :-</b> Structured roadmap for risk management.</li>
                        <li><b>Implementation Guidance  :-</b> Step-by-step assistance with compliance activities.</li>
                        <li><b>Compliance Readiness Review  :-</b> Mock audit for internal validation.</li>
                        <li><b>Ongoing Compliance Support  :-</b> Continuous monitoring and periodic reviews.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/*---------- TAB AND PILL SEC ---------- */}

              {/* ------- OUR APPROACH SEC ------ */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach </h3>
                  <ul>
                    <li><b>Compliance-First Mindset :-</b> We ensure your organization not only achieves compliance but also sustains it year after year.</li>
                    <li><b>Tailored to Your Business :-</b> We design compliance programs that fit your unique industry, size, and regulatory needs.</li>
                    <li><b>Certified Experts :-</b> Our team of ISO 27001 Lead Auditors brings deep knowledge of compliance frameworks.</li>
                    <li><b>End-to-End Engagement :-</b> From gap analysis to audit preparation and post-certification maintenance.</li>
                    <li><b>Cross-Industry Expertise :-</b> We’ve worked with clients across finance, healthcare, IT, government, and manufacturing.</li>
                    <li><b>Value Beyond Compliance :-</b> We ensure ISO 27001 compliance also delivers tangible security improvements.</li>
                  </ul>
                </div>
              </div>
              {/* ------- OUR APPROACH SEC ------ */}
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
